import {call, put} from "redux-saga/effects";
import {setClinicInfo, setError, setLoading, setSuccess} from "../../slices/businessSlice";
import {setClinics, setUpdateStatusIndex} from "../../slices/businessSlice";
import {getClinicInfoService, getClinicsService, setClinicStatusService} from "../requests/businessService";
import {toast} from "react-toastify";

export function* handleGetClinics(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => getClinicsService(action.payload))
    yield put(setClinics(response.data))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export function* handleSetClinicStatus(action) {
  const query = action.payload

  try {
    const response = yield call(() => setClinicStatusService(query))
    yield put(setUpdateStatusIndex({
      index: action.payload.index,
      status: query.status,
    }))
    if (query.status === 'DOCUMENT_VERIFIED') {
      toast.success(`Documents verified successfully`)
    } else if (query.status === 'DOCUMENT_UNVERIFIED') {
      toast.info(`Documents has been unverified`)
    } else {
      toast.success(`Business status changed successfully`)
    }
    yield put(setSuccess())
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)

  }
}

export function* handleGetClinicInfo(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => getClinicInfoService(action.payload))
    yield put(setClinicInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError(errorMsg))
  }
}